import React from "react";

export default function FooterCTA({
    title,
    subtitle,
    primaryCta,
    secondaryCta,
}: {
    title: string;
    subtitle: string;
    primaryCta: { label: string; href: string };
    secondaryCta: { label: string; href: string };
}) {
    return (
        <section className="mx-auto max-w-6xl px-4 pb-16 sm:px-6">
            <div className="rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur sm:p-10">
                <div className="grid gap-6 lg:grid-cols-[1fr_auto] lg:items-center">
                    <div>
                        <div className="text-2xl font-semibold tracking-tight text-white">{title}</div>
                        <p className="mt-2 text-sm text-white/70">{subtitle}</p>
                    </div>
                    <div className="flex flex-col gap-3 sm:flex-row">
                        <a
                            href={primaryCta.href}
                            className="rounded-2xl bg-white px-5 py-3 text-sm font-medium text-black hover:bg-white/90 transition text-center"
                        >
                            {primaryCta.label}
                        </a>
                        <a
                            href={secondaryCta.href}
                            className="rounded-2xl border border-white/10 bg-white/5 px-5 py-3 text-sm text-white/80 hover:bg-white/10 transition text-center"
                        >
                            {secondaryCta.label}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
